export default "__VITE_ASSET__u8oDppP$__"